import React from 'react';
import { usePrice } from '@jetshop/core/hooks/usePrice';
import { useDynamicPrice } from '@jetshop/core/hooks/useDynamicPrice';
import t from '@jetshop/intl';
import { Currency } from '@jetshop/ui/Price/Currency';
import { getSavedAmount } from '../../../helpers';
import Styled from './Style';

const ProductUSPList = ({ product, variant }) => {
  const usps = product.customFields?.find(field => {
    return field.key.startsWith('usp-');
  });
  const price = useDynamicPrice(product, variant);
  const { hasDiscount } = usePrice(price);

  if (!usps) return null;

  return (
    <Styled.USPList>
      {hasDiscount && (
        <Styled.ListItem>
          <Styled.USPCheck />
          {t('you save')}
          <Styled.Saving>
            <Currency value={getSavedAmount(price)} />
          </Styled.Saving>
        </Styled.ListItem>
      )}
      {usps.listValues?.map((value, index) => {
        return (
          <Styled.ListItem key={value + index}>
            <Styled.USPCheck /> {value}
          </Styled.ListItem>
        );
      })}
    </Styled.USPList>
  );
};

export default ProductUSPList;
